<template>
  <span class="bg-green-2 flex h-3 w-3 grow-0 rounded-full">
    <svg
      width="4"
      height="6"
      class="m-auto"
      viewBox="0 0 4 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.142 5.784C1.014 5.928 0.855557 6 0.666668 6C0.478224 6 0.320002 5.93125 0.192002 5.79375C0.0640023 5.65625 2.30681e-06 5.48125 2.30681e-06 5.26875V0.75C-0.000442137 0.538 0.0633354 0.36 0.191335 0.216C0.319335 0.0720001 0.47778 0 0.666668 0C0.855112 0 1.01333 0.0687497 1.14133 0.20625C1.26933 0.34375 1.33333 0.51875 1.33333 0.73125V5.25C1.33378 5.462 1.27 5.64 1.142 5.784Z"
        fill="white"
      />
      <path
        d="M3.80866 5.784C3.68067 5.928 3.52222 6 3.33333 6C3.14489 6 2.98667 5.93125 2.85867 5.79375C2.73067 5.65625 2.66667 5.48125 2.66667 5.26875V0.75C2.66622 0.538 2.73 0.36 2.858 0.216C2.986 0.0720001 3.14444 0 3.33333 0C3.52178 0 3.68 0.0687497 3.808 0.20625C3.936 0.34375 4 0.51875 4 0.73125V5.25C4.00044 5.462 3.93666 5.64 3.80866 5.784Z"
        fill="white"
      />
    </svg>
  </span>
</template>
